// const uuidv5 = require('uuid/v5');

// export default function generateUUID() {
//     const uuid = "web-" + uuidv5((Math.floor(Math.random() * Math.floor(10000000)).toString() + (Date.now() % 1000) / 1000).toString() + 'KID_WEB' , uuidv5('kid.family.evi.com', uuidv5.DNS));
//     return uuid;
// }

import { v4 as uuidv4 } from 'uuid'; 

export const generateUUID = () => {
  if (typeof window === 'undefined') return null; // server side error: cannot generate UUID
  const uuid = crypto.randomUUID ? crypto.randomUUID() : uuidv4(); // using browser crypto API (recommend) or fallback to uuidv4()
  return uuid; 
};